import React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import StepConnector from '@mui/material/StepConnector';
import clsx from 'clsx';
import Check from '@mui/icons-material/Check';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { makeStyles } from 'tss-react/mui';
import { withStyles } from 'tss-react/mui';

const ColorlibConnector = withStyles(StepConnector,
    () => ({
        root: {
            minHeight: '30px',
        },
        alternativeLabel: {
            top: 12,
            left: 'calc(-50% - 5px)',
            right: 'calc(50%)',
        },
        line: {
            height: 1,
            border: 0,
            backgroundColor: '#000',
            borderRadius: 1,
        },
    }),)

const useColorlibStepIconStyles = makeStyles()({
    root: {
        backgroundColor: '#ccc',
        zIndex: 1,
        color: '#fff',
        width: 24,
        height: 24,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    circle: {
        backgroundColor: '#7f7f73',
    },
    active: {
        backgroundColor: '#c9ca4a',
    },
    completed: {
        backgroundColor: '#c9ca4a',
        color: '#fff',
        borderRadius: '50%',
    },
});

const ColorlibStepIcon = (props) => {
    const { classes } = useColorlibStepIconStyles();
    const { active, completed } = props;

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
            })}
        >
            {
                completed ? (
                    <Check className={classes.completed} />
                ) : active ? (
                    <Check className={classes.completed} />
                ) : (
                    <div className={classes.circle} />
                )
            }
        </div>
    );
}

ColorlibStepIcon.propTypes = {
    // Whether this step is active.
    active: PropTypes.bool,
    //  Mark the step as completed. Is passed to child components.
    completed: PropTypes.bool,
};

const useStyles = makeStyles()((theme) => {
    return {
        root: {
            width: '100%',
            '& .MuiStepper-root': {
                padding: theme.spacing(3, 0),
                '& .MuiStep-horizontal': {
                    padding: theme.spacing(0),
                    width: '20%',
                    margin: theme.spacing(1),
                },
            },
            '& .MuiListItem-root': {
                padding: theme.spacing(0),
                '& .MuiListItemText-root': {
                    flex: '1 1',
                    margin: theme.spacing(0.25),
                    '& .MuiTypography-body1': {
                        fontSize: '0.6rem',
                        fontFamily: 'Avenir-Heavy',
                    },
                    '& .MuiTypography-body2': {
                        fontSize: '0.6rem',
                        fontFamily: 'Avenir-Medium',
                    },
                },
            },
            '& .MuiTypography-body2': {
                fontSize: '0.8rem',
                fontFamily: 'Avenir-Medium',
            },
            '& .MuiTypography-body1': {
                fontSize: '0.6rem',
                fontFamily: 'Avenir-Heavy',
            },
            '& .MuiTypography-subtitle1': {
                fontSize: '0.6rem',
                // fontFamily: 'Avenir-Heavy',
            },
            '& .MuiStepConnector-alternativeLabel': {
                // left: 'calc(-50%)',
                // right: 'calc(50%)',
                '& .MuiStepConnector-lineHorizontal': {
                    borderWidth: '1px',
                },
            },
            '& .MuiStepIcon-root.MuiStepIcon-completed': {
                color: '#c4c745',
            },
        },
        backButton: {
            marginRight: theme.spacing(1),
        },
        instructions: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
    }
});

const getSteps = (data) => {
    switch (data.Status) {
        case 'Assigned':
            if (data.AssignedDateTime) {
                return {
                    steps: 0,
                    data: [
                        {
                            key: 'Assigned',
                            date: data.AssignedDateTime
                                ? moment
                                    .utc(data.AssignedDateTime)
                                    .tz('America/Chicago')
                                    .format('MMMM DD, YYYY hh:mm:ss a')
                                : '',
                            data: [],
                        },
                        {
                            key: 'Loading',
                            date: '',
                            data: [],
                        },
                        {
                            key: 'Loaded',
                            date: '',
                            data: [],
                        },
                        {
                            key: 'Unloading',
                            date: '',
                            data: [],
                        },
                        {
                            key: 'Delivered',
                            date: '',
                            data: [],
                        },
                    ],
                };
            } else {
                return {
                    steps: -1,
                    data: [
                        {
                            key: 'Assigned',
                            date: '',
                            data: [],
                        },
                        {
                            key: 'Loading',
                            date: '',
                            data: [],
                        },
                        {
                            key: 'Loaded',
                            date: '',
                            data: [],
                        },
                        {
                            key: 'Unloading',
                            date: '',
                            data: [],
                        },
                        {
                            key: 'Delivered',
                            date: '',
                            data: [],
                        },
                    ],
                };
            }
        case 'Loading':
            return {
                steps: 1,
                data: [
                    {
                        key: 'Assigned',
                        date: data.AssignedDateTime
                            ? moment
                                .utc(data.AssignedDateTime)
                                .tz('America/Chicago')
                                .format('MMMM DD, YYYY hh:mm:ss a')
                            : '',
                        data: [],
                    },
                    {
                        key: 'Loading',
                        date: data.AtOriginIn
                            ? moment
                                .utc(data.AtOriginIn)
                                .tz('America/Chicago')
                                .format('MMMM DD, YYYY hh:mm:ss a')
                            : '',
                        data: [],
                    },
                    {
                        key: 'Loaded',
                        date: '',
                        data: [],
                    },
                    {
                        key: 'Unloading',
                        date: '',
                        data: [],
                    },
                    {
                        key: 'Delivered',
                        data: [],
                    },
                ],
            };
        case 'Loaded':
            return {
                steps: 2,
                data: [
                    {
                        key: 'Assigned',
                        date: data.AssignedDateTime
                            ? moment
                                .utc(data.AssignedDateTime)
                                .tz('America/Chicago')
                                .format('MMMM DD, YYYY hh:mm:ss a')
                            : '',
                        data: [],
                    },
                    {
                        key: 'Loading',
                        date: data.AtOriginIn
                            ? moment
                                .utc(data.AtOriginIn)
                                .tz('America/Chicago')
                                .format('MMMM DD, YYYY hh:mm:ss a')
                            : '',
                        data: [],
                    },
                    {
                        key: 'Loaded',
                        date: data.AtOriginOut
                            ? moment
                                .utc(data.AtOriginOut)
                                .tz('America/Chicago')
                                .format('MMMM DD, YYYY hh:mm:ss a')
                            : '',
                        data: [],
                    },
                    {
                        key: 'Unloading',
                        text: ``,
                        date: '',
                        data: [],
                    },
                    {
                        key: 'Delivered',
                        date: '',
                        data: [],
                    },
                ],
            };
        case 'Unloading':
            return {
                steps: 3,
                data: [
                    {
                        key: 'Assigned',
                        date: data.AssignedDateTime
                            ? moment
                                .utc(data.AssignedDateTime)
                                .tz('America/Chicago')
                                .format('MMMM DD, YYYY hh:mm:ss a')
                            : '',
                        data: [],
                    },
                    {
                        key: 'Loading',
                        date: data.AtOriginIn
                            ? moment
                                .utc(data.AtOriginIn)
                                .tz('America/Chicago')
                                .format('MMMM DD, YYYY hh:mm:ss a')
                            : '',
                        data: [],
                    },
                    {
                        key: 'Loaded',
                        date: data.AtOriginOut
                            ? moment
                                .utc(data.AtOriginOut)
                                .tz('America/Chicago')
                                .format('MMMM DD, YYYY hh:mm:ss a')
                            : '',
                        data: [],
                    },
                    {
                        key: 'Unloading',
                        date: data.AtDestinationIn
                            ? moment
                                .utc(data.AtDestinationIn)
                                .tz('America/Chicago')
                                .format('MMMM DD, YYYY hh:mm:ss a')
                            : '',
                        data: [],
                    },
                    {
                        key: 'Delivered',
                        date: '',
                        data: [],
                    },
                ],
            };
        case 'Delivered':
            return {
                steps: 4,
                data: [
                    {
                        key: 'Assigned',
                        date: data.AssignedDateTime
                            ? moment
                                .utc(data.AssignedDateTime)
                                .tz('America/Chicago')
                                .format('MMMM DD, YYYY hh:mm:ss a')
                            : '',
                        data: [],
                    },
                    {
                        key: 'Loading',
                        date: data.AtOriginIn
                            ? moment
                                .utc(data.AtOriginIn)
                                .tz('America/Chicago')
                                .format('MMMM DD, YYYY hh:mm:ss a')
                            : '',
                        data: [],
                    },
                    {
                        key: 'Loaded',
                        date: data.AtOriginOut
                            ? moment
                                .utc(data.AtOriginOut)
                                .tz('America/Chicago')
                                .format('MMMM DD, YYYY hh:mm:ss a')
                            : '',
                        data: [],
                    },
                    {
                        key: 'Unloading',
                        date: data.AtDestinationIn
                            ? moment
                                .utc(data.AtDestinationIn)
                                .tz('America/Chicago')
                                .format('MMMM DD, YYYY hh:mm:ss a')
                            : '',
                        data: [],
                    },
                    {
                        key: 'Delivered',
                        date: data.AtDestinationOut
                            ? moment
                                .utc(data.AtDestinationOut)
                                .tz('America/Chicago')
                                .format('MMMM DD, YYYY hh:mm:ss a')
                            : '',
                        data: [],
                    },
                ],
            };
        default:
            return {
                steps: -1,
                data: [
                    {
                        key: 'Assigned',
                        date: '',
                        data: [],
                    },
                    {
                        key: 'Loading',
                        text: ``,
                        date: '',
                        data: [],
                    },
                    {
                        key: 'Loaded',
                        text: ``,
                        date: '',
                        data: [],
                    },
                    {
                        key: 'Unloading',
                        text: ``,
                        date: '',
                        data: [],
                    },
                    {
                        key: 'Delivered',
                        date: '',
                        data: [],
                    },
                ],
            };
    }
}

interface NotificationStepperForAssetLoadProps {
    jsonData: any;
}

const NotificationStepperForAssetLoad = ({ jsonData }: NotificationStepperForAssetLoadProps) => {
    const { classes } = useStyles();
    const steps = getSteps(jsonData);
    return (
        <div className={classes.root}>
            <Stepper activeStep={steps.steps} alternativeLabel connector={<ColorlibConnector />}>
                {steps.data.map(label => (
                    <Step key={label.key}>
                        <StepLabel StepIconComponent={ColorlibStepIcon}>{label.key}</StepLabel>
                        <Typography
                            align="center"
                            variant="subtitle1"
                            className={label.date?.length == 0 ? 'date-lg-font mb-1rem' : 'date-lg-font'}
                        >
                            {label.date}
                        </Typography>
                    </Step>
                ))}
            </Stepper>
        </div>
    );
};

export default NotificationStepperForAssetLoad;
